import { useState } from "react";

type EditorState<T> = {
  productKey: string;
  field: string;
  value: T;
} | null;

export const useBasketEditor = <T = unknown>() => {
  const [activeEditor, setActiveEditor] = useState<EditorState<T>>(null);

  const openEditor = (productKey: string, field: string, value: T) => {
    setActiveEditor({ productKey, field, value });
  };

  const closeEditor = () => {
    setActiveEditor(null);
  };

  const isEditorOpen = (productKey: string, field: string) => {
    return (
      activeEditor?.productKey === productKey && activeEditor?.field === field
    );
  };

  const updateValue = (value: T) => {
    if (activeEditor) {
      setActiveEditor({ ...activeEditor, value });
    }
  };

  const getValue = <V = T>(): V | undefined => {
    return activeEditor?.value as unknown as V | undefined;
  };

  return {
    activeEditor,
    openEditor,
    closeEditor,
    isEditorOpen,
    updateValue,
    getValue,
  };
};
